import FileUpload from "@nkr/components/file-upload";
import { IWatrChaseImport } from "@nkr/models/index";
import { useState } from "react";
import { Alert, Button, Modal, Table } from "react-bootstrap";
import { FileRejection, DropEvent } from 'react-dropzone';

interface IProps {
    show: boolean,
    onOnFileUpload: (file: File) => void
    onClose: () => void,
    data?: IWatrChaseImport[]
}

const ChaseTransactionUpload = (props: IProps) => {
    if (!props.show) {
        return <></>;
    }
    
    const [files, setFiles] = useState<File[]>([]);
    
    const handleFileDropped = (acceptedFiles: File[], fileRejections: FileRejection[], event: DropEvent) => {
        setFiles(acceptedFiles);
    };
    
    const handleRemoveFile = (name: string) => {
        setFiles([]);
    };

    const handleSubmit = () => {
        props.onOnFileUpload(files[0])
        setFiles([])
    };

    const cancel = () => {
        setFiles([]);
        props.onClose();
    }
    
    return (
            <Modal backdrop='static' show={props.show} onHide={props.onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>
                        Import Chase ACH Transactions CSV
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    {props.data && <>
                        <Alert bsStyle="danger" >The following records could not be processed.</Alert>
                        <Table striped bordered condensed hover>
                            <thead>
                                <tr>
                                    <th>#</th>
                                    <th>Pay To</th>
                                    <th>Amount</th>
                                    <th>Send On</th>
                                    <th>Chase Transaction Number</th>
                                </tr>
                            </thead>
                            <tbody>
                                {props.data.map((r, i) => (
                                    <tr>
                                        <td>{i + 1}</td>
                                        <td>{r.payTo}</td>
                                        <td>{r.amount}</td>
                                        <td>{r.sendOn}</td>
                                        <td>{r.chaseTransactionNumber}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table>
                    </>}
                    {!props.data && <>
                        <FileUpload
                            label="Click to Select or Drag and Drop the transaction file ..."
                            files={files}
                            accept={['.csv']}
                            singleUploadOnly={true}
                            onFileDropped={handleFileDropped}
                            onRemoveFile={handleRemoveFile} />
                    </>}
                </Modal.Body>
                <Modal.Footer>
                    {props.data && <>
                        <Button bsStyle="danger" onClick={cancel} >Continue</Button>
                    </>}
                    {!props.data && <>
                        <Button disabled={!(files && files.length > 0)} bsStyle='primary' onClick={handleSubmit}>Process Transactions</Button>
                        <Button onClick={cancel} >Cancel</Button>
                    </>}
                </Modal.Footer>
            </Modal>
        );
    }
    
export default ChaseTransactionUpload;